"use client"

import { useEffect, useRef, useState } from "react"
import { useOrganizationList } from "@clerk/nextjs"

import { apiContextFetch } from "@/hooks/api/base"
import { useDevAuth } from "@/hooks/use-dev-auth"

export function markLoginCompanyApplied(sessionId: string | null | undefined) {
  if (sessionId) localStorage.setItem("slant-login-company-session", sessionId)
}

export function useLoginCompany(enabled: boolean) {
  const { isLoaded, isSignedIn, sessionId, orgId, getToken, sessionClaims } = useDevAuth()
  const { isLoaded: organizationsLoaded, setActive } = useOrganizationList()
  const [ready, setReady] = useState(false)
  const started = useRef(false)

  useEffect(() => {
    if (!enabled || !isLoaded || !isSignedIn || started.current) return
    if (!sessionId || sessionClaims?.act || localStorage.getItem("slant-login-company-session") === sessionId) {
      setReady(true)
      return
    }
    if (!organizationsLoaded) return
    started.current = true
    const apply = async () => {
      const token = await getToken()
      const result = await apiContextFetch<{ company_id: string | null; clerk_organization_id: string | null }>(
        { token: token ?? undefined },
        "login_company"
      )
      if (result.company_id && result.clerk_organization_id !== (orgId ?? null)) {
        await setActive?.({ organization: result.clerk_organization_id })
        markLoginCompanyApplied(sessionId)
        localStorage.removeItem("slant-query-cache")
        window.location.replace(
          window.location.pathname === "/redirect" ? `/redirect${window.location.search}` : "/redirect?to=dashboard"
        )
        return
      }
      markLoginCompanyApplied(sessionId)
      setReady(true)
    }
    // Login must remain usable if a preference lookup or Clerk switch fails.
    void apply().catch(() => setReady(true))
  }, [enabled, getToken, isLoaded, isSignedIn, orgId, organizationsLoaded, sessionClaims, sessionId, setActive])

  return ready
}
